import { Component, HostBinding, Input } from '@angular/core';
import { NkNavVerticalCollapseComponent } from '../nav-collapse/nav-vertical-collapse.component';
import { NkNavVerticalItemComponent } from '../nav-item/nav-vertical-item.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nav-vertical-group',
  templateUrl: './nav-vertical-group.component.html',
  styleUrls: ['./nav-vertical-group.component.scss'],
  standalone: true,
  imports:[
    NkNavVerticalCollapseComponent,
    NkNavVerticalItemComponent,
    CommonModule
  ]
})
export class NkNavVerticalGroupComponent {
  @HostBinding('class') classes = 'nav-group nav-item';
  @Input() item: any;

}
